import { IepTimerMode } from '../types/accommodations';

const IEP_TIMER_MULTIPLIERS: Record<Exclude<IepTimerMode, 'untimed'>, number> = {
  standard: 1,
  '1.5x': 1.5,
  '2x': 2
};

export function getAccommodationTimerDuration(
  baseDuration: number,
  iepAccommodationsEnabled: boolean | undefined,
  timerMode: IepTimerMode | undefined
): number {
  if (!iepAccommodationsEnabled || timerMode === 'standard') return baseDuration;
  const resolvedMode = timerMode ?? '2x';
  if (resolvedMode === 'untimed') return baseDuration;
  return baseDuration * IEP_TIMER_MULTIPLIERS[resolvedMode];
}

export function isAccommodationTimerUntimed(
  iepAccommodationsEnabled: boolean | undefined,
  timerMode: IepTimerMode | undefined
): boolean {
  return iepAccommodationsEnabled === true && timerMode === 'untimed';
}

export function getAccommodationMasteryThreshold(iepAccommodationsEnabled: boolean | undefined): number {
  return iepAccommodationsEnabled ? 2 : 3;
}

export function getUpdatedDemonstrationCount(
  currentCount: number,
  successful: boolean,
  iepAccommodationsEnabled: boolean | undefined,
  minimum = -4,
  maximum = 3
): number {
  const change = successful ? 1 : iepAccommodationsEnabled ? 0 : -2;
  return Math.min(Math.max(currentCount + change, minimum), maximum);
}

export function getAccuracyEvaluationWindow(): {
  attemptWindow: number;
  minimumEngagementAttempts: number;
} {
  return { attemptWindow: 10, minimumEngagementAttempts: 8 };
}
